
import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogProps,
} from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';
import {
  GenericTableComponent,
  TableConfig,
  TableCellDirective,
} from 'src/app/shared/components/generic-table';
import { CpfMaskPipe } from 'src/app/shared/pipes/cpf-mask.pipe';
import { CnpjMaskPipe } from 'src/app/shared/pipes/cnpj-mask.pipe';
import { AlertIndicatorVariation } from '../models/wallet-alert-report.models';
import { TruncatedTextComponent } from 'src/app/shared/components/truncated-text/truncated-text.component';

export interface RegistrationDataAlertsDialogData {
  cardData: AlertIndicatorVariation;
  registryDocument: string;
}

export interface RegistrationDataRow {
  label: string;
  value: string;
}

@Component({
  selector: 'app-registration-data-alerts-dialog',
  templateUrl: './registration-data-alerts-dialog.component.html',
  styleUrl: './registration-data-alerts-dialog.component.scss',
  imports: [
    ConfirmationDialogComponent,
    GenericTableComponent,
    TableCellDirective,
    TruncatedTextComponent
],
})
export class RegistrationDataAlertsDialogComponent {
  readonly props: ConfirmationDialogProps;
  readonly formattedRegistryDocument: string;
  readonly rows = signal<RegistrationDataRow[]>([]);
  readonly isLoading = signal(false);
  readonly tableConfig = this.buildTableConfig();

  private readonly cpfPipe = new CpfMaskPipe();
  private readonly cnpjPipe = new CnpjMaskPipe();

  constructor(
    private readonly dialogRef: MatDialogRef<RegistrationDataAlertsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: RegistrationDataAlertsDialogData,
  ) {
    this.props = {
      title: data.cardData.indicatorGroup,
      cancelButton: { hide: true },
    };
    this.formattedRegistryDocument =
      data.registryDocument.length > 11
        ? this.cnpjPipe.transform(data.registryDocument)
        : this.cpfPipe.transform(data.registryDocument);

    this.isLoading.set(true);
  }

  resolveRegistrationData(rows: RegistrationDataRow[] | null): void {
    this.rows.set(rows ?? []);
    this.isLoading.set(false);
  }

  private buildTableConfig(): TableConfig<RegistrationDataRow> {
    return {
      columns: [
        {
          id: 'label',
          title: $localize`:@@partnerRegistrationFieldLabel:Campo`,
          textAlign: 'left',
          width: '250px',
          hasCustomContent: true,
          getValue: (row) => row.label || '-',
        },
        {
          id: 'value',
          title: $localize`:@@partnerRegistrationFieldValue:Valor`,
          textAlign: 'left',
          hasCustomContent: true,
          getValue: (row) => row.value || '-',
        },
      ],
    };
  }
}
